<h2 mat-dialog-title>{{data.title | translate}}</h2>
<div mat-dialog-content>
  <app-simpletable [cols]="data.cols" [data]="data.data" [datatype]="data.datatype" [datatypePlural]="data.datatypePlural"></app-simpletable>
</div>
